import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Card, Collapse, IconButton, Typography } from "@mui/material";
import type { FC } from "react";
import { SystemValidationTextField } from "../../../components/UIToolkit/Inputs/SystemValidationTextField";
import { NEUTRAL } from "../../../theme/tokens";

interface StaffingParametersProps {
	census: number;
	setCensus: (value: number) => void;
	targetHppd: number;
	setTargetHppd: (value: number) => void;
	callOffCount: number;
	setCallOffCount: (value: number) => void;
	ptoDaily: number;
	setPtoDaily: (value: number) => void;
	isOpen: boolean;
	onToggleOpen: () => void;
}

export const StaffingParameters: FC<StaffingParametersProps> = ({
	census,
	setCensus,
	targetHppd,
	setTargetHppd,
	callOffCount,
	setCallOffCount,
	ptoDaily,
	setPtoDaily,
	isOpen,
	onToggleOpen,
}) => {
	return (
		<Card
			data-testid="hiring-params"
			sx={{
				p: 1.5,
				border: `1px solid ${NEUTRAL[200]}`,
				boxShadow: "none",
				borderRadius: "8px",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
				<Typography sx={{ fontWeight: 600, color: "primary.main" }}>Staffing Parameters</Typography>
				<IconButton size="small" onClick={onToggleOpen} sx={{ color: "primary.main" }}>
					{isOpen ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
				</IconButton>
			</Box>
			<Collapse in={isOpen} timeout="auto" unmountOnExit>
				<Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, mt: 1 }}>
					<Box sx={{ minWidth: 160 }}>
						<Typography sx={{ fontSize: "13px", fontWeight: 600, color: "text.secondary", mb: 0.5 }}>Census</Typography>
						<SystemValidationTextField
							inputType="number"
							value={String(census)}
							onChange={(e) => setCensus(Number(e.target.value))}
							variant="standard"
							reserveHeightForHelperText={false}
						/>
					</Box>
					<Box sx={{ minWidth: 160 }}>
						<Typography sx={{ fontSize: "13px", fontWeight: 600, color: "text.secondary", mb: 0.5 }}>Target HPPD</Typography>
						<SystemValidationTextField
							inputType="number"
							value={String(targetHppd)}
							onChange={(e) => setTargetHppd(Number(e.target.value))}
							variant="standard"
							reserveHeightForHelperText={false}
						/>
					</Box>
					<Box sx={{ minWidth: 200 }}>
						<Typography sx={{ fontSize: "13px", fontWeight: 600, color: "text.secondary", mb: 0.5 }}>Call Offs (daily)</Typography>
						<SystemValidationTextField
							inputType="number"
							value={String(callOffCount)}
							onChange={(e) => {
								const next = Number(e.target.value);
								setCallOffCount(Number.isNaN(next) ? 0 : Math.max(0, next));
							}}
							variant="standard"
							reserveHeightForHelperText={false}
						/>
					</Box>
					<Box sx={{ minWidth: 200 }}>
						<Typography sx={{ fontSize: "13px", fontWeight: 600, color: "text.secondary", mb: 0.5 }}>PTO (daily)</Typography>
						<SystemValidationTextField
							inputType="number"
							value={String(ptoDaily)}
							onChange={(e) => {
								const next = Number(e.target.value);
								setPtoDaily(Number.isNaN(next) ? 0 : Math.max(0, next));
							}}
							variant="standard"
							reserveHeightForHelperText={false}
						/>
					</Box>
				</Box>
			</Collapse>
		</Card>
	);
};
